import { RouteObject } from 'react-router-dom';

import { Help } from 'pages/help';

import PrivateRoute from '../hoc/PrivateRoute';

export const helpRoutes: RouteObject[] = [
  {
    path: '/help',
    element: (
      <PrivateRoute>
        <Help />
      </PrivateRoute>
    ),
  },
];
